"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createScreeningProcedures = createScreeningProcedures;
const shared_1 = require("../../shared");
const messages_1 = require("./messages");
const queries_1 = require("../queries");
const messages = {
    screeningProcedures: {
        id: "dashboard.screening_procedures",
        defaultMessage: "Szűrővizsgálatok"
    },
    chestXray: {
        id: "dashboard.chest_xray",
        defaultMessage: "Mellkas rtg."
    },
    chestCt: {
        id: "dashboard.chest_ct",
        defaultMessage: "Mellkas CT"
    },
    abdominalUltrasound: {
        id: "dashboard.abdominal_ultrasound",
        defaultMessage: "Hasi UH."
    },
    urology: {
        id: "dashboard.urology",
        defaultMessage: "Urológia"
    },
    gynecology: {
        id: "dashboard.gynecology",
        defaultMessage: "Nőgyógyászat"
    },
    psychiatry: {
        id: "dashboard.psychiatry",
        defaultMessage: "Pszichiátria"
    },
    stoolBlood: {
        id: "dashboard.stool_blood",
        defaultMessage: "Széklet vér"
    },
    urinesediment: {
        id: "dashboard.urinesediment",
        defaultMessage: "Vizelet üledék"
    },
    urineculture: {
        id: "dashboard.urineculture",
        defaultMessage: "Vizelettenyésztés"
    },
    stoolculture: {
        id: "dashboard.stoolculture",
        defaultMessage: "Széklettenyésztés"
    },
    carotisDoppler: {
        id: "dashboard.carotis_doppler",
        defaultMessage: "Nyaki UH"
    },
    ophthalmologicExamination: {
        id: "dashboard.ophthalmologic_examination",
        defaultMessage: "Szemészet"
    },
    mammography: {
        id: "dashboard.mammography",
        defaultMessage: "Mammográfia"
    },
    earNoseThroat: {
        id: "dashboard.ear_nose_throat",
        defaultMessage: "Fül-orr-gégészet"
    },
    abi: {
        id: "dashboard.abi",
        defaultMessage: "Boka-kar index"
    },
    proteinuria: {
        id: "dashboard.proteinuria",
        defaultMessage: "Proteinuria"
    },
    colonoscopy: {
        id: "dashboard.colonoscopy",
        defaultMessage: "Colonoscopia"
    },
    dexa: {
        id: "dashboard.dexa",
        defaultMessage: "DEXA"
    },
    dentalScreening: {
        id: "dashboard.dental_screening",
        defaultMessage: "Fogászat"
    },
    dermatology: {
        id: "dashboard.dermatology",
        defaultMessage: "Bőrgyógyászat"
    },
    pulmonology: {
        id: "dashboard.pulmonology",
        defaultMessage: "Pulmonológia"
    }
};
var ScreeningProcedureResult;
(function (ScreeningProcedureResult) {
    ScreeningProcedureResult["NORMAL"] = "NORMAL";
    ScreeningProcedureResult["ABNORMAL"] = "ABNORMAL";
})(ScreeningProcedureResult || (ScreeningProcedureResult = {}));
const groups = [
    {
        label: messages_1.messages.abnormal,
        variant: "dark",
        predicate: (event) => event !== undefined &&
            event.value === ScreeningProcedureResult.ABNORMAL
    },
    {
        label: messages_1.messages.normal,
        variant: "light",
        predicate: (event) => event !== undefined &&
            event.value === ScreeningProcedureResult.NORMAL
    }
];
const values = [
    {
        label: messages.chestXray,
        query: queries_1.queries.chestXray
    },
    {
        label: messages.chestCt,
        query: queries_1.queries.chestCt
    },
    {
        label: messages.abdominalUltrasound,
        query: queries_1.queries.abdominalUltrasound
    },
    {
        label: messages.urology,
        query: queries_1.queries.urology
    },
    {
        label: messages.gynecology,
        query: queries_1.queries.gynecology
    },
    {
        label: messages.psychiatry,
        query: queries_1.queries.psychiatry
    },
    {
        label: messages.stoolBlood,
        query: queries_1.queries.stoolBlood
    },
    {
        label: messages.urinesediment,
        query: queries_1.queries.urinesediment
    },
    {
        label: messages.urineculture,
        query: queries_1.queries.urineculture
    },
    {
        label: messages.stoolculture,
        query: queries_1.queries.stoolculture
    },
    {
        label: messages.carotisDoppler,
        query: queries_1.queries.carotisDoppler
    },
    {
        label: messages.ophthalmologicExamination,
        query: queries_1.queries.ophthalmologicExamination
    },
    {
        label: messages.mammography,
        query: queries_1.queries.mammography
    },
    {
        label: messages.earNoseThroat,
        query: queries_1.queries.earNoseThroat
    },
    {
        label: messages.abi,
        query: queries_1.queries.abi
    },
    {
        label: messages.proteinuria,
        query: queries_1.queries.proteinuria
    },
    {
        label: messages.colonoscopy,
        query: queries_1.queries.colonoscopy
    },
    {
        label: messages.dexa,
        query: queries_1.queries.dexa
    },
    {
        label: messages.dentalScreening,
        query: queries_1.queries.dentalScreening
    },
    {
        label: messages.dermatology,
        query: queries_1.queries.dermatology
    },
    {
        label: messages.pulmonology,
        query: queries_1.queries.pulmonology
    }
];
function createScreeningProcedures(intl, { events }) {
    const list = (0, shared_1.createGroupList)(intl, { events, groups, values });
    const content = (0, shared_1.createSectionContent)([list]);
    return (0, shared_1.createSection)(intl, {
        label: messages.screeningProcedures,
        content
    });
}
